export const hostnames = [
  'anvil.localhost',
  'app.ens.domains',
  'app.uniswap.org',
  'bluestake.vercel.app',
  'bungee.exchange',
  'cartel.sh',
  'cctp.exchange',
  'cut-v2.mattlovan.dev',
  'daimo.ngrok.app',
  'eco.com',
  'happypath.enso.build',
  'id.porto.sh',
  'jumper.exchange',
  'localhost',
  'paper.ink',
  'pay.daimo.com',
  'playground.li.fi',
  'playground.porto.sh',
  'portal.eco.com',
  'porto.sh',
  'preview.porto.sh',
  'rath.fi',
  'relay.link',
  'sponsor-porto.vercel.app',
  'stg.localhost',
  'swap.defillama.com',
  'uniswap.org',
  'www.bungee.exchange',
]
